import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';

import api from '../../../api/axios';
import { IApiResponseError, IApiState } from '../../../types/api';
import { RootState } from '../..';

interface IGetTransactionCategoriesResponse {
  status?: boolean;
  message?: string;
  data?: {
    id: string;
    name: string;
    description?: string;
    createdAt: string;
    updatedAt: string;
  }[];
  errors?: IApiResponseError[];
}

const initialState: IApiState<IGetTransactionCategoriesResponse> = {
  value: null,
  status: 'idle',
  error: '',
};

export const getTransactionCategoriesAsync = createAsyncThunk(
  'transactionCategories',
  async (_, { rejectWithValue, getState }) => {
    try {
      const state = getState() as RootState;

      const accessToken = state.auth.value?.data?.token?.accessToken;

      const businessId =
        localStorage.getItem('businessId') ||
        state.auth.value?.data?.user?.businesses?.[0]?.id;

      const config = {
        headers: {
          Authorization: `Token ${accessToken}`,
          'X-Business-Id': businessId,
        },
      };

      const { data } = await api.get('/transaction/categories', config);

      return data;
    } catch (err) {
      const error = err as AxiosError<IApiResponseError>;

      return rejectWithValue(error.response?.data);
    }
  }
);

export const transactionCategoriesGetSlice = createSlice({
  name: 'transactionCategories/get',
  initialState,
  reducers: {
    resetGetTransactionCategories: (state) => {
      state.value = null;
      state.status = 'idle';
      state.error = '';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getTransactionCategoriesAsync.pending, (state) => {
        state.status = 'loading';
        state.error = '';
      })
      .addCase(getTransactionCategoriesAsync.fulfilled, (state, action) => {
        state.status = 'success';
        state.value = action.payload as IGetTransactionCategoriesResponse;
      })
      .addCase(getTransactionCategoriesAsync.rejected, (state, action) => {
        state.status = 'failed';
        state.value = action.payload as IGetTransactionCategoriesResponse;
        state.error = action.error.message;
      });
  },
});

export const { resetGetTransactionCategories } =
  transactionCategoriesGetSlice.actions;

export default transactionCategoriesGetSlice.reducer;
